// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

const work = [
  {
    title: "Fractured Veil",
    tags: ["UX Design", "UI Design", "eCommerce", "Mobile", "ReactJS"],
    component: "WorkFracturedVeil"
  },
  {
    title: "Paddle Creek Games",
    tags: ["Branding", "Identity"],
    component: "WorkPcg"
  },
  {
    title: "Kuaa",
    tags: ["UX Design", "UI Design", "Mobile", "ReactJS"],
    component: "WorkKuaa"
  },
  {
    title: "Mcgee",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkMcgee"
  },
  {
    title: "Klymit",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkKlymit"
  },
  {
    title: "Ogg",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkOgg"
  },
  {
    title: "BlackDiamond",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkBlackDiamond"
  },
  {
    title: "WorkBlackDiamondS",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkBlackDiamondS"
  },
  {
    title: "Olympic",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkOlympic"
  },
  {
    title: "Chapul",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkChapul"
  },
  {
    title: "Leaf",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkLeaf"
  },
  {
    title: "Mbj",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkMbj"
  },
  {
    title: "Sharpko",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkSharpko"
  },
  {
    title: "Tucker",
    tags: ["UX Design", "UI Design", "eCommerce", "Magento"],
    component: "WorkTucker"
  },
  {
    title: "Smmgs",
    tags: ["3d Modeling", "CAD", "Laser Cutting", "Soldering", "PCB Design"],
    component: "WorkSmmgs"
  },
  {
    title: "Manimal",
    tags: ["Identity", "Branding", "Product Design"],
    component: "WorkManimal"
  }
];

const experiences = [
  {
    company: "Western Governors University",
    title: "Staff Software Engineer",
    dates: "June 2019\u2013Present",
    location: "Salt Lake City, Utah (Remote)",
    website: "www.wgu.edu",
    desc:
      "Portfolio lead on student-facing applications. Designed and developed core enterprise code. Lead portfolio initiatives for accessibility, performance, and security. Develop and maintain design systems and common component libraries for the student experience.",
    techs: [
      "Angular",
      "Nx",
      "CI/CD",
      "Monorepo",
      "Module Federation",
      "AWS",
      "Figma",
      "TailwindCSS",
      "Cypress",
      "Accessibility",
    ]
  },
  {
    company: "Paddle Creek Games",
    title: "Senior Designer / Front-End Developer",
    dates: "2016\u2013June 2019",
    location: "Seattle, WA (Remote)",
    website: "www.fracturedveil.com",
    desc:
      "Designed and developed companion website for the massively online multiplayer game Fractured Veil. Systems built include eCommerce, social networks, team management, and in-game integrations using React; Designed in-game UI wireframes.",
    techs: [
      "React",
      "Redux",
      "Express",
      "Webpack",
      "ES6",
      "Emotion",
      "HTML5",
      "SCSS",
      "Adobe",
      "XD",
      "Adobe Illustrator",
      "Adobe Photoshop",
      "Adobe After Effects",
      "InVision"
    ]
  },
  {
    company: "Self Employed",
    title: "Freelance Interactive Designer",
    dates: "2014\u20132016",
    location: "Salt Lake City, Utah",
    desc:
      "Freelanced as a web and graphic designer for businesses such as DayOne Baby (San Francisco), Studio McGee (Salt Lake City), Klymit (Kaysville), Leaf Audio (Salt Lake City), Heart of Haute (San Dimas), Desert Tech (Salt Lake City) and many more. Specialized in eCommerce design, development, identity, and marketing.",
    techs: [
      "Magento",
      "WordPress",
      "Sage",
      "Bedrock",
      "Trellis",
      "HTML5",
      "SCSS",
      "jQuery",
      "Ruby on Rails",
      "WordPress",
      "Adobe Illustrator",
      "Adobe Photoshop",
      "Sketch",
      "InVision"
    ]
  },
  {
    company: "Schawel+Coles",
    title: "Senior Designer / Front-End Developer",
    dates: "2012\u20132014",
    location: "Salt Lake City, Utah",
    website: "www.schawelcoles.com",
    desc:
      "Designed, developed, and launched dozens of successful eCommerce websites using the Magento platform. Developed custom Magento Extensions for particular customer needs. Worked directly with founders to establish a clientele.",
    techs: [
      "Magento",
      "HTML5",
      "SCSS",
      "jQuery",
      "Adobe Illustrator",
      "Adobe Photoshop",
      "Sketch",
      "InVision"
    ]
  },
  {
    company: "Cognate Creative LLC",
    title: "Senior Designer / Front-End Developer",
    dates: "2009\u20132012",
    location: "Salt Lake City, Utah",
    desc:
      "Designed web interfaces, mobile apps, logos, and marketing material for clients. Designed and built custom eCommerce solutions from the ground up.",
    techs: [
      "Magento",
      "WordPress",
      "Django",
      "HTML5",
      "SCSS",
      "jQuery",
      "WordPress",
      "Adobe Illustrator",
      "Adobe Photoshop"
    ]
  },
  {
    company: "Thirsty Pixel",
    title: "Designer / Front-End Developer",
    dates: "2007\u20132009",
    location: "Salt Lake City, Utah",
    desc:
      "Information architecture and UX/UI design for client projects. Designed and helped build a content management system. Planned and designed admin interface for tracking millions of tires for the tire retreading industry.",
    techs: [
      "PHP",
      "xHMTL/CSS",
      "CakePHP",
      "jQuery",
      "Javascript",
      "WordPress",
      "Adobe Illustrator",
      "Adobe Photoshop"
    ]
  },
  {
    company: "i4 Solutions",
    title: "Designer / Front-End Developer",
    dates: "2003\u20132007",
    location: "Woods Cross, Utah",
    desc:
      "Designed and developed web sites, logos, marketing materials, and identity for clients. Designed in-house visual website editor and content management system. Design and front-end development for custom eCommerce solution.",
    techs: [
      "PHP",
      "xHMTL/CSS",
      "Javascript",
      "ASP",
      "ASP.net",
      "Adobe Illustrator",
      "Adobe Photoshop"
    ]
  }
];
const references = [
  {
    name: "Chris DiBona",
    titles: [
      "Director, Open-Source (Google)",
      "Founder, CEO (Paddle Creek Games)"
    ],
    email: "cdibona@paddlecreekgames.com",
    desc:
      "A world leader in the use, creation, and release of open source and free software. A fantastic developer relations person with significant experience on television, radio, online, and in front of large, varied audiences. Extensive press government, and antitrust regulator relations work."
  },
  {
    name: "Matthew Coles",
    titles: ["Creative Director (Schawel+Coles)"],
    email: "m@schawelcoles.com",
    desc:
      "Oversees all projects at Schawel+Coles, an eCommerce agency building beautiful, effective sites on Magento, Volusion and BigCommerce platforms."
  }
];

export { work, experiences, references };



// WEBPACK FOOTER //
// ./src/helpers/data.js